<template>
    <div class="sort__group">
        <a class="sort__layout sort__layout--1 sort__layout--active"
           @click="setLayout('big')">
        </a>
        <a class="sort__layout sort__layout--2"
           @click="setLayout('small')">
        </a>
    </div>
</template>

<script>
    export default {
        methods: {
            setLayout(type) {

                $('.category__item-list').find('.blur-effect').addClass('loading');

                setTimeout(function () {
                    if(type === 'big') {
                        $('.category__item-list').removeClass('category__item-list--small');
                        $('.sort__layout--2').removeClass('sort__layout--active');
                        $('.sort__layout--1').addClass('sort__layout--active');
                    }

                    if(type === 'small') {
                        $('.category__item-list').addClass('category__item-list--small');
                        $('.sort__layout--1').removeClass('sort__layout--active');
                        $('.sort__layout--2').addClass('sort__layout--active');
                    }
                }, 500);


                setTimeout(function () {
                    $('.category__item-list').find('.blur-effect').removeClass('loading');
                }, 1000);
            }
        }
    }
</script>
